import { InvoiceData } from "./InvoiceData";

export const DataPersonalInvoice = () => {
  return (
    <div className="main-layout-container mx-3">
      <div className="main-panel">
        <InvoiceData />
      </div>
    </div>
  );
};
